app.service('question',function(loading, productCardConfig, validate, login, answer, modal, captchaService, text) {
	var $questionForm, $questionFormBox;
	var config;

	function addInfo(question){
		config=productCardConfig.getData();
		var itemValue = localStorage.getItem('qq'+config.id) || false;
		if(itemValue){
			question=itemValue.split('|')[0];
			var text=itemValue.split('|')[1];
			var box=$('#questions');
			if(box.length){
				var div=box.find('.success-question');
				if(!div.length){
					div=$('<div/>').addClass('success-box success-question').attr('id','success-question-'+question).html(text).appendTo(box);
				}
			}
		}
	}
	function parseBadWordsResponse($selector) {
		$selector.each(function() {
			$(this).val($(this).val().replace(/<span style="color:red">/g, '').replace(/<\/span>/g, ''));
		});
	}
	function loadForm(){
		if(!$questionForm || !$questionForm.length){
			config=productCardConfig.getData();
			$questionFormBox=$('#question-form-box');
			$questionFormBox.addClass('loading');
			$.ajax({
				url:'/product-question-form.ltr',
				data:{
					productId:config.id
				},
				success:function(html){
					loadFormSuccess(html);
				},
				error:function(){
					modal.alert('Wystąpił błąd ładowania formularza. Prosimy spróbować później');
				},
				complete:function(){
					$self.removeClass('loading');
				}
			});
		}
		$.scrollTo( $questionFormBox );
	}

	function loadFormSuccess(html){
		$questionFormBox.removeClass('loading');
		if(html){
			$questionFormBox.html(html);
			parseBadWordsResponse($('#question-content', $questionFormBox));
		}
		setEvents();
		//$.scrollTo($questionFormBox);
		validate.task('question',function(){
			send();
			UA.pageInteraction('Pytania i Odpowiedzi', 'Dodaj pytanie');
		});
		addQuestionCaptcha();
	}

	function addQuestionCaptcha() {
		var $captcha = $questionForm.find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}

	function send(){
		login.checkUniqueNick(function(){
			$questionForm.addClass('loading');
			$questionForm.ajaxSubmit({
				url:'/product-question-form.ltr',
				data:{
					productId:config.id,
					ACTION:'SAVE'
				},
				type:'POST',
				beforeSubmit: function(payload) {
					const content = payload.find(el => el.name == 'content');
					content.value = text.clean(content.value);
				},
				success:function(html){
					sendSuccess(html);
				},
				error:function(){
					modal.alert('Wystąpił błąd wysyłania pytania. Prosimy spróbować później');
				},
				comlete:function(){
					$questionForm.removeClass('loading');
				}
			});
		}, 'pytania');
	}
	function changePage(page){
		load({'pageNr':page},{method:'append'});
	}
	function changeOrder(){
		load({'pageNr':1},{method:'replace'});
	}
	function load(ajaxData, option){
		var options={
			method:'replace'
		};
		$.extend(true,options,option);
		var config=productCardConfig.getData();
		var data={
			'product-link-name': config.linkName,
			'pageNr':1
		};
		if($('.js-questions-order').length){
			data.sort=$('.js-questions-order').val();
		}
		data=$.extend(true,data,ajaxData);
		loading.start();
		var url="/product-card-questions.ltr";
		$.ajax({
			url:url,
			type:'GET',
			data:data,
			success:function(html){
				if(options.method=='append'){
					$('#questions-box .more-load-questions-box').remove();
					$('#questions-box .questions-list').append($('<div>'+html+'</div>').find('.questions-list').html());
				}else{
					$('#questions-box').html(html);
					$.scrollTo($('#questions-box'));
				}
				if(option.callback){
					option.callback();
				}
				$('.questions-list .question-item').each(function(){
					answer.addInfo($(this).attr('id').substr(9));
				});
			},
			complete:function(){
				loading.stop();
			},
			error:function(){
				modal.alert('Błąd ładowania. Brak danych do zakładki');
			}
		});
	}
	function setEvents() {
		$questionForm=$('form',$questionFormBox);
		$('.js-question-type', $questionForm).click(function(){
			UA.pageInteraction('Pytania i Odpowiedzi', 'Zadaj pytanie - ' + $(this).val());
		});
	}
	function sendSuccess(html){
		$questionFormBox.removeClass('loading');
		if(html){
			loadFormSuccess(html);
		}
		var div = $('#success-question');
		if(div.length){
			var name='qq'+config.id;
			var value=div.data('question-token')+'|'+div.html();
			var expires=1/24/60*parseInt(div.data('time'));
			localStorage.setItem(name, value, expires);
		}
	}
	return {
		loadForm:loadForm,
		load:load,
		changePage:changePage,
		changeOrder:changeOrder,
		addInfo:addInfo
	};
});
